import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import {
  Params,
  Schedule,
  ScheduleFinalizePayload,
  SchedulePayload,
} from "@/types";

const endpoint = {
  schedules: "/schedules",
};

export const fetchSchedule = createAsyncThunk(
  "schedules/fetchSchedule",
  async (params: Params, thunkAPI) => {
    try {
      console.log("📡 Buscando schedules com parâmetros:", params);

      const response = await axiosInstance.get(endpoint.schedules, { params });

      console.log("✅ Schedules buscados com sucesso:", response.data);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao buscar agendamentos.",
        });
      }
    }
  },
);

export const createSchedule = createAsyncThunk(
  "schedules/createSchedule",
  async (data: Omit<SchedulePayload, "id">, thunkAPI) => {
    try {
      console.log("📝 Criando agendamento com dados:", data);
      const response = await axiosInstance.post(endpoint.schedules, data);
      console.log("✅ Agendamento criado com sucesso:", response.data);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao criar agendamento.",
        });
      }
    }
  },
);

export const updateSchedule = createAsyncThunk(
  "schedules/updateSchedule",
  async (data: SchedulePayload, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.schedules}/${data.id}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao atualizar agendamento.",
        });
      }
    }
  },
);

export const deleteSchedule = createAsyncThunk(
  "schedules/deleteSchedule",
  async (id: number, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.schedules}/${id}`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao excluir agendamento.",
        });
      }
    }
  },
);

export const markScheduleAs = createAsyncThunk(
  "scheduleProducts/markScheduleAs",
  async (
    { scheduleId, status }: { scheduleId: number | null; status: string },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.patch(
        `${endpoint.schedules}/${scheduleId}/${status}`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const finalizeSchedule = createAsyncThunk(
  "schedules/finalize",
  async (
    {
      data,
      scheduleId,
    }: { scheduleId: number | null; data: ScheduleFinalizePayload },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.post(
        `${endpoint.schedules}/${scheduleId}/finalize`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const reopenSchedule = createAsyncThunk(
  "schedules/reopen",
  async ({ scheduleId }: { scheduleId: number | null }, thunkAPI) => {
    try {
      // POST to /schedules/{id}/reopen - follows the existing finalize pattern
      const response = await axiosInstance.post(
        `${endpoint.schedules}/${scheduleId}/reopen`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const blockedSchedule = createAsyncThunk(
  "schedules/blocked",
  async (
    { data, scheduleId }: { scheduleId: number | null; data: any },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.post(
        `${endpoint.schedules}/${scheduleId}/blocked`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
